<template>
  <nav>
    <v-app-bar app clipped-right color="primary" dark>
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        v-if="loggedIn"
      ></v-app-bar-nav-icon>
      <v-toolbar-title>DashBoard</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app>
      <v-list dense v-if="loggedIn">
        <v-list-item two-line class="px-0" @click="viewProfile()">
          <v-list-item-avatar>
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/User_icon_2.svg/220px-User_icon_2.svg.png"
            />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ getName }}</v-list-item-title>
            <v-list-item-subtitle>Super Admin</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list-item-group v-model="model">
          <router-link to="/" class="text-decoration-none">
            <v-list-item>
              <v-list-item-icon>
                <span class="iconsSidbar">
                  <i class="fa fa-home"></i>
                </span>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Dashboard</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <v-list>
            <v-list-group>
              <template v-slot:activator>
                <v-list-item-icon>
                  <span class="iconsSidbar">
                    <i class="fab fa-windows"></i>
                  </span>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>System</v-list-item-title>
                </v-list-item-content>
              </template>

              <router-link to="/languages" class="text-decoration-none">
                <v-list-item>
                  <v-list-item-icon>
                    <span class="iconsSidbar ml-6">
                      <i class="fas fa-globe"></i>
                    </span>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Languages</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </router-link>

              <router-link to="/categories" class="text-decoration-none">
                <v-list-item>
                  <v-list-item-icon>
                    <span class="iconsSidbar ml-6">
                      <i class="fas fa-layer-group"></i>
                    </span>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Categories</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </router-link>
            </v-list-group>
          </v-list>


          <router-link to="/users" class="text-decoration-none">
            <v-list-item>
              <v-list-item-icon>
                <span class="iconsSidbar ">
                  <i class="fas fa-users"></i>
                </span>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Users</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/authors" class="text-decoration-none">
            <v-list-item>
              <v-list-item-icon>
                <span class="iconsSidbar ">
                  <i class="fas fa-pen-alt"></i>
                </span>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Authors</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/publishers" class="text-decoration-none">
            <v-list-item>
              <v-list-item-icon>
                <span class="iconsSidbar ">
                  <i class="fas fa-print"></i>
                </span>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Publishers</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <v-list>
            <v-list-group>
              <template v-slot:activator>
                <v-list-item-icon>
                  <span class="iconsSidbar">
                    <i class="fas fa-book"></i>
                  </span>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Books Manager</v-list-item-title>
                </v-list-item-content>
              </template>

              <router-link to="/books" class="text-decoration-none">
                <v-list-item>
                  <v-list-item-icon>
                    <span class="iconsSidbar ml-6">
                      <i class="fas fa-book-open"></i>
                    </span>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Books</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </router-link>

              <!-- <router-link to="/categories" class="text-decoration-none">
                <v-list-item>
                  <v-list-item-icon>
                    <span class="iconsSidbar ml-6">
                      <i class="fas fa-layer-group"></i>
                    </span>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Categories</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </router-link> -->

            </v-list-group>
          </v-list>

          <router-link to="/microes" class="text-decoration-none">
            <v-list-item>
              <v-list-item-icon>
                <span class="iconsSidbar ">
                  <i class="fas fa-link"></i>
                </span>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Microes</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>




          <router-link to="/logout" class="text-decoration-none">
            <v-list-item @click="drawer = !drawer">
              <v-list-item-icon>
                <span class="iconsSidbar">
                  <i class="fas fa-sign-out-alt"></i>
                </span>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>LogOut</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<style scoped>
.iconsSidbar {
  color: #767676;
  font-size: 17px;
}
</style>
<script>
export default {
  data: () => ({
    drawer: false,
    model: 0,
    items: [
      {
        action: "mdi-ticket",
        items: [{ title: "List Item" }],
        title: "Attractions",
      },
      {
        action: "mdi-silverware-fork-knife",
        active: true,
        items: [
          { title: "Breakfast & brunch" },
          { title: "New American" },
          { title: "Sushi" },
        ],
        title: "Dining",
      },
      {
        action: "mdi-school",
        items: [{ title: "List Item" }],
        title: "Education",
      },
      {
        action: "mdi-run",
        items: [{ title: "List Item" }],
        title: "Family",
      },
      {
        action: "mdi-bottle-tonic-plus",
        items: [{ title: "List Item" }],
        title: "Health",
      },
      {
        action: "mdi-content-cut",
        items: [{ title: "List Item" }],
        title: "Office",
      },
      {
        action: "mdi-tag",
        items: [{ title: "List Item" }],
        title: "Promotions",
      },
    ],
  }),
  computed: {
    loggedIn() {
      return this.$store.getters.loggedIn;
    },
    getName() {
      return this.$store.getters.getName;
    },
  },
  methods: {
    viewProfile() {
      this.$router.push({ name: "Me" }).catch(() => {});
    },
  },
};
</script>
